var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { ref: "beforeContent" }, [_vm._t("default")], 2),
      _vm.hasSlider
        ? _c(
            "div",
            {
              ref: "sliderContent",
              staticClass: "mb-lg-n4",
              class: _vm.isSticky ? "sticky-bottom shadow-up" : "",
            },
            [
              _vm._t("sliderContent", null, {
                windowIsScrolled: _vm.windowIsScrolled,
              }),
            ],
            2
          )
        : _vm._t("otherContent"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }